export default function SuppliersHeroFr() {
  return (
    <section className="relative w-full h-[280px] md:h-[340px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-top" style={{ backgroundImage: "url('https://public.readdy.ai/ai/img_res/b24a9c8f5dd19a65572724570dc9c967.jpg')" }} />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/60 to-stone-900/30" />
      <div className="relative z-10 w-full px-6 md:px-16">
        <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest block mb-3">Réseau mondial vérifié</span>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>Fournisseurs</h1>
        <p className="text-white/70 text-base max-w-xl leading-relaxed">Un réseau sélectionné de fabricants et partenaires qualifiés en Amérique du Nord, en Europe et en Asie.</p>
      </div>
    </section>
  );
}
